<template>
  <div class="agree-bg">
    <!--    <quill-editor style="background-color: #fff;"  :max-width="400" v-model="content" ref="myQuillEditor" :disabled="true" :content="content" :options="editorOption">
        </quill-editor>-->

    <!--    文章内容-->
    <div class="detail_con ql-container ql-snow" :style="loading ? 'height:200px;width:400px;' : 'height:auto;width:900px'"
         v-loading="loading"
         element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="ql-editor" ref="blogContentRef" @click="clickImage" v-html="content"></div>
    </div>

    <!-- v-highlight    文章目录-->

    <div style="width: 50%;">
      <div class="directory" style="position: sticky;top:10%;right: 11px;font-size: 12px" >
        <!--      <div style="display: flex ;justify-items: center ; align-items: center">
                <svg style="width: 25px;height: 25px" t="1708918460345" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4251" width="200" height="200"><path d="M853.333333 218.666667a37.333333 37.333333 0 0 1 3.072 74.538666L853.333333 293.333333H362.666667a37.333333 37.333333 0 0 1-3.072-74.538666L362.666667 218.666667h490.666666zM853.333333 474.666667a37.333333 37.333333 0 0 1 3.072 74.538666L853.333333 549.333333H362.666667a37.333333 37.333333 0 0 1-3.072-74.538666L362.666667 474.666667h490.666666zM853.333333 730.666667a37.333333 37.333333 0 0 1 3.072 74.538666L853.333333 805.333333H362.666667a37.333333 37.333333 0 0 1-3.072-74.538666L362.666667 730.666667h490.666666z" fill="#000000" p-id="4252"></path><path d="M202.666667 256m-53.333334 0a53.333333 53.333333 0 1 0 106.666667 0 53.333333 53.333333 0 1 0-106.666667 0Z" fill="#000000" p-id="4253"></path><path d="M202.666667 512m-53.333334 0a53.333333 53.333333 0 1 0 106.666667 0 53.333333 53.333333 0 1 0-106.666667 0Z" fill="#000000" p-id="4254"></path><path d="M202.666667 768m-53.333334 0a53.333333 53.333333 0 1 0 106.666667 0 53.333333 53.333333 0 1 0-106.666667 0Z" fill="#000000" p-id="4255"></path></svg>
                <h2>目录</h2>
              </div>-->
        <ul style="position: fixed;transform: translate3d(0px, 0px, 0px);">
          <div v-for="(item, index) in catalog">
            <!---根据read属性，动态绑定样式：为true即为正在阅读此内容--->
            <li :key="index" :style="{ paddingLeft: item.level * 30 - 44 + 'px' }" :class="{ ll: item.read == true }">
              <!---设置href，用于目录的跳转；动态绑定id，判断当前正在阅读的是哪一个小标题的内容--->
              <span :id="item.id" @click="goAnchor(index, '#' + item.id)" :class="{ cc: item.read == true }"
                    v-html="item.title"></span>  <!-- :class="item.class" -->
            </li>
          </div>
        </ul>
      </div>
    </div>


  </div>

</template>
<script>
import {quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import {getAssist} from "@/api/assist";


const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],        // 加粗，斜体，下划线，删除线
  ['blockquote', 'code-block'],                      //引用，代码块
  [{'header': 1}, {'header': 2}],               // 几级标题
  [{'list': 'ordered'}, {'list': 'bullet'}],     // 有序列表，无序列表
  [{'script': 'sub'}, {'script': 'super'}],      // 下角标，上角标
  [{'indent': '-1'}, {'indent': '+1'}],          // 缩进
  [{'direction': 'rtl'}],                         // 文字输入方向
  [{'size': ['small', false, 'large', 'huge']}],  // 字体大小
  [{'header': [1, 2, 3, 4, 5, 6, false]}],// 标题
  [{'color': []}, {'background': []}],          // 颜色选择
  [{'font': ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial']}],// 字体
  [{'align': []}], // 居中
  ['clean'],                                       // 清除样式,
  ['link', 'image'],  // 上传图片、上传视频
]
export default {
  components: {
    quillEditor
  },
  data() {
    return {
      content: '',
      scroll: '',
      editorOption: {
        placeholder: '请在这里输入',
        theme: 'bubble', //主题 snow/bubble
        modules: {
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function (value) {
                if (value) {
                  // 调用element的图片上传组件
                  document.querySelector('#upload').click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      },
      loading: true,
      catalog: []
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 初始化文本框 这里固定第一条数据就行
      getAssist(1).then(res => {
        this.content = res.data.content
        this.getTitle();
      })
    },

    // 这个方法没有使用，可以不管
    clickImage() {
    },

    // 目录锚点跳转
    goAnchor(index, id) {
      // 被点击的目录对应内容中的标题样式改变
      for (let i = 0; i < this.catalog.length; i++) {
        if (index === i) {
          this.catalog[i].read = true
          // document.getElementById(this.catalog[i].id).style.color = '#4d99f1'
        } else {
          this.catalog[i].read = false
          // document.getElementById(this.catalog[i].id).style.color = '#666'
        }
      }
      // 参数是id选择器
      document.querySelector(id).scrollIntoView({
        behavior: 'smooth', // 动画过渡效果-behavior: "auto" 或 "smooth" 默认为 "auto"
        block: 'center', // 垂直方向对齐-block: "start", "center", "end", 或 "nearest" 默认为 "start"
        inline: 'center' // 水平方向对齐-inline: "start", "center", "end", 或 "nearest" 默认为 "nearest"
      })
    },

    // 获取博客文章目录
    getTitle() {
      // 生成目录
      this.$nextTick(() => {
        // 根据ref来获取文章的标题
        const articleContent = this.$refs.blogContentRef
        // 想获取的标题，将想获取的标题的标签添加到这  目前只支持三级标题，后续可以继续添加 'H4' 'H5' 'H6'
        const titleTag = ['H1', 'H2', 'H3']
        // 存放标题的数组
        const titles = []
        // 遍历标题节点
        articleContent.childNodes.forEach((e, index) => {
          // 找出需要做成目录的标题并在内容中给这些标题添加id属性(可用于锚点跳转)
          if (titleTag.includes(e.nodeName)) {
            // 具体封装过程
            const id = 'header-' + index
            // 设置元素id
            e.setAttribute('id', id)
            // 最终目录
            titles.push({
              id: id,
              title: e.innerHTML,
              level: Number(e.nodeName.substring(1, 2)),
              nodeName: e.nodeName,
              // read：后期主要用来判断当前阅读的是哪一个小标题的内容
              read: false,
              class: id
            })
          }
        })
        // 最终目录赋值给catalog
        this.catalog = titles
        // loading
        this.loading = false
      })
    },


    // 元素当前显示位置
    dataScroll() {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    },

    // 鼠标下滑时发生事件
    loadScroll() {
      const articleContent = this.$refs.blogContentRef
      const titleTag = ['H1', 'H2', 'H3']
      articleContent.childNodes.forEach((e, index) => {
        if (titleTag.includes(e.nodeName)) {
          var elementId = e.getAttribute('id', 'header-' + index);

          // 获取元素id
          if (this.scroll >= e.offsetTop - 50) {
            // document.querySelector('#'+elementId).style.color='#409EFF'
            document.querySelector('.' + elementId).style.color = '#409EFF'
          } else {
            document.querySelector('#' + elementId).style.color = ''
            document.querySelector('.' + elementId).style.color = ''
          }
        }
      })
    },

  },
  watch: {
    //监听scroll变量，只要滚动条位置变化就会执行方法loadScroll
    scroll() {
      //this.loadScroll()
    }
  },
  mounted() {
    // scroll代表滚动条距离页面顶部距离
    // window.addEventListener('scroll', this.dataScroll);
  }

}
</script>

<style scoped>

.agree-bg {
  width: 100%;
  background: #F4F4F4;
  //overflow: hidden;
  display: flex;
  justify-content: center;
  position: relative;
}

.directory {
/*  position: sticky;
  right: 0;
  top: 0;*/
}

.directory ul li {
  cursor: pointer;
  margin-bottom: 3px;
}

.directory ul li:hover {
  color: #56abda;
}

.directory .cc {
  color: #4d99f1;
}

.ql-container {
  height: 800px;
}

.ql-container.ql-snow {
  border: 0;
}

</style>